import { ApiErrorResponse } from "@/_models/common";
import { mainApiInstance } from "../_axiosInstance";
import { SubscriptionPreviewData } from "@/_components/ui/paymentDialogs/dialog.types";

interface IGetTokenAndSavedMethodResponse {
  token: string;
  payment_method_id: string;
}
const getTokenAndSavedMethod = async () => {
  try {
    const response = await mainApiInstance.get<IGetTokenAndSavedMethodResponse>(
      "/payment/customer-auth-token",
    );
    return response.data;
  } catch (error) {
    throw error as ApiErrorResponse;
  }
};

export interface ProductCatalogItem {
  id: string;
  name: string;
  amount: string;
  currencyCode: string;
  product_id: string;
}

export interface ProductCatalogResponse {
  items: ProductCatalogItem[];
}

const getProductPrice = async () => {
  try {
    const response =
      await mainApiInstance.get<ProductCatalogResponse>("/payment/catalog");
    return response.data;
  } catch (error) {
    throw error as ApiErrorResponse;
  }
};

const getUpdatePaymentDetailTnxId = async () => {
  try {
    const response = await mainApiInstance.get<{ id: string }>(
      "/payment/update-payment",
    );
    return response.data;
  } catch (error) {
    throw error as ApiErrorResponse;
  }
};

const getAdjustmentPreview = async (
  adjustPriceId: string,
  promotionCode?: string,
) => {
  try {
    const response = await mainApiInstance.put<SubscriptionPreviewData>(
      `/payment/update-payment/preview`,
      {
        to_price_id: adjustPriceId,
        promotion_code: promotionCode,
      },
    );
    return response.data;
  } catch (error) {
    throw error as ApiErrorResponse;
  }
};

const confirmAdjustPlan = async (priceId: string, promotionCode?: string) => {
  try {
    const response = await mainApiInstance.put(
      `/payment/update-payment/confirm`,
      {
        to_price_id: priceId,
        promotion_code: promotionCode,
      },
    );
    return response.data;
  } catch (error) {
    throw error as ApiErrorResponse;
  }
};

const cancelPlan = async () => {
  try {
    const response = await mainApiInstance.post(`/payment/subscription/cancel`);
    return response.data;
  } catch (error) {
    throw error as ApiErrorResponse;
  }
};

export const paddleService = {
  getTokenAndSavedMethod,
  getProductPrice,
  getUpdatePaymentDetailTnxId,
  getAdjustmentPreview,
  confirmAdjustPlan,
  cancelPlan,
};
